<template>
	<div class="tournament">
		<SubHeader
			title="JDO Tournament Prize Winner"
			subtitle="JDOトーナメント入賞者"
		/>

		<div class="container">
			<ul class="nav nav-pills mb-3" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2026"> 2026年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link active" href="javascript:void(0);"> 2025年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2024"> 2024年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2023"> 2023年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2022"> 2022年度 </a>
				</li>
			</ul>

			<div id="20250329_niigata" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.3.29 新潟 Darts Open Tournament 2025</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img
								src="/images/jdo/2026/niigata/niigata_01.jpg"
								class="img-fluid"
							/>
							<span class="name">稲井 雄士・白畑 諒大</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2026/niigata/niigata_03.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2026/niigata/niigata_02.jpg"
								class="img-fluid"
							/>
							<span class="name">田上 さやか</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20260222_kyoto" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.2.22 第20回 京都ダーツ オープントーナメント2026</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2026/kyoto/kyoto_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img
								src="/images/jdo/2026/kyoto/kyoto_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 俊太・松浦 広貴</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img
								src="/images/jdo/2026/kyoto/kyoto_03.jpg"
								class="img-fluid"
							/>
							<span class="name">柳瀬 将一・門川 翔太</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2026/kyoto/kyoto_04.jpg"
								class="img-fluid"
							/>
							<span class="name">大本 直樹・高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20251207_kagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.12.07 香川ダーツオープントーナメント2025</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2025/kagawa/kagawa_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 優勝</span>
							<img
								src="/images/jdo/2025/kagawa/kagawa_02.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/kagawa/kagawa_03.jpg"
								class="img-fluid"
							/>
							<span class="name">田上 さやか</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20251109_kanagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.11.09 第25回 AKDO OPEN DARTS TOURNAMENT</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img
								src="/images/jdo/2025/kanagawa2/kanagawa_01.jpg"
								class="img-fluid"
							/>
							<span class="name">大本 直樹・柳瀬 将一</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/kanagawa2/kanagawa_02.jpg"
								class="img-fluid"
							/>
							<span class="name">柳瀬 将一</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20251011_interleague" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.10.11 JDO INTERLEAGUE CHAMPIONSHIP 2025</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">優勝</span>
							<img
								src="/images/jdo/2025/interleague/rampage.jpg"
								class="img-fluid"
							/>
							<span class="name"
								>RAMPAGE<br />（黒川 智成、外筬 久人、髙橋 綾也、浅井
								佑介）</span
							>
						</p>
					</div>
				</div>
			</div>

			<div id="20250914_nagano" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.09.14 NAGANO DARTS OPEN TOURNAMENT 2025</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img
								src="/images/jdo/2025/nagano/nagano_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶・大本 直樹</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250913_masters" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.09.13 JDO MASTER'S 2025</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/masters/masters_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250831_hiroshima" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.08.31 HIROSHIMA OPEN DARTS TOUNAMENT</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img src="/images/jdo/noimage_700x600.jpg" class="img-fluid" />
							<span class="name">稲井 雄士・白畑 諒大</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2025/hiroshima2/hiroshima_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250803_hyogo" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.08.10 OPEN DARTS TOUNAMENT IN EHIME 2025</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">レディースシングルス 準優勝</span>
							<img
								src="/images/jdo/2025/ehime/ehime_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/ehime/ehime_02.jpg"
								class="img-fluid"
							/>
							<span class="name">田上 さやか</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250803_hyogo" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.08.03 第34回 H.D.O.オープンダーツトーナメント</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2025/hyogo/hyogo_01.jpg"
								class="img-fluid"
							/>
							<span class="name">黒川 智成</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 準優勝</span>
							<img
								src="/images/jdo/2025/hyogo/hyogo_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20231112_kanagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.07.13 OKAYAMA OPEN DARTS TOURNAMENT 2025</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/okayama/okayama_01.jpg"
								class="img-fluid"
							/>
							<span class="name">全 恵美</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250518_nara" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.05.18 第5回 奈良ダーツ オープントーナメント2025</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img src="/images/jdo/2025/nara/nara_02.jpg" class="img-fluid" />
							<span class="name">田 達輝・大達 浩司</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img src="/images/jdo/2025/nara/nara_03.jpg" class="img-fluid" />
							<span class="name">西岡 健太郎・杉山 祐貴</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img src="/images/jdo/2025/nara/nara_01.jpg" class="img-fluid" />
							<span class="name">木本 一恵</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 準優勝</span>
							<img src="/images/jdo/2025/nara/nara_04.jpg" class="img-fluid" />
							<span class="name">白畑 諒大</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img src="/images/jdo/2025/nara/nara_05.jpg" class="img-fluid" />
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250420_kochi" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.04.20 KOCHI OPEN DARTS TOURNAMENT vol.15</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025//kochi/kochi_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 優勝</span>
							<img
								src="/images/jdo/2025//kochi/kochi_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import SubHeader from "@/components/common/SubHeader.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "tournament2020",
	components: {
		SubHeader,
	},
	data() {
		return {};
	},
	mounted: function () {},
	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
	font-size: 1.6rem;
	margin-bottom: 1rem;
}
h4 {
	border-bottom: solid 3px #333;
	padding-bottom: 5px;
	margin-bottom: 2rem;
	position: relative;
	&:before {
		content: "";
		width: 3rem;
		height: 3px;
		background-color: $primary-color;
		display: block;
		position: absolute;
		left: 0;
		bottom: -3px;
	}
}
a {
	text-decoration: underline;
}
.container {
	padding: 4rem 1rem;
	text-align: left;
}
.btn-download {
	font-size: 1rem;
	color: #333;
	border: none;
	margin-top: 1rem;
	background: $primary-color;
	text-decoration: none;
	cursor: pointer;
	&:hover {
		color: #333;
		background-color: $secondary-color;
	}
	&:active {
		color: #333;
		background-color: $secondary-color;
	}
}
.rank,
.rank_winner,
.rank_2nd,
.rank_3rd,
.name {
	color: #333;
}
.rank_winner {
	font-size: 2rem;
	i {
		color: #dbb400;
	}
}
.rank_2nd {
	font-size: 1.4rem;
	i {
		color: #9fa0a0;
	}
}
.rank_3rd {
	font-size: 1.4rem;
	i {
		color: #c47022;
	}
}
i {
	margin-right: 0.6rem;
}
</style>
